import React from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import { TouchApp as TouchAppIcon } from "@mui/icons-material";

import ParkkiTheme from "themes/ParkkiTheme";

const StyledTouchAppIcon = styled(TouchAppIcon)`
  font-size: 30px;
  margin-right: ${ParkkiTheme.spacings.tiny};
`;

const InfoComponent = styled.div`
  display: flex;
  align-items: center;
`;

type SelectALayerInfoProps = {
  message?: string | undefined;
};

function SelectALayerInfo({ message }: SelectALayerInfoProps) {
  const { formatMessage } = useIntl();

  return (
    <InfoComponent>
      <StyledTouchAppIcon />
      <div>
        {message ??
          formatMessage({ id: "components.selectALayerInfo.selectALayer" })}
      </div>
    </InfoComponent>
  );
}

export default SelectALayerInfo;
